import { Stack, styled } from "@mui/material"

export const GPStack = styled(Stack)({
  height: "80vh",
  width: "100%",
  padding: "0px 20px 20px 20px ",
  backgroundColor: "#F8F9FA",
  // border: "1px solid red"
})
